import { useEffect, useRef, useState } from "react";
import { MoreVertical, Trash2 } from "lucide-react";
import { F, T } from "../../theme/tokens";

export interface DetailAction { label: string; icon: React.ReactNode; onClick: () => void }

// Phone replacement for the "Admin actions" card (Figma): one wide destructive button,
// with the secondary actions tucked behind a ⋮ menu. Hidden on desktop (.phone-only).
export function DetailActionBar({ deleteLabel = "Delete account", onDelete, items }: { deleteLabel?: string; onDelete?: () => void; items: DetailAction[] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <div className="phone-only detail-actionbar" ref={ref} style={{ position: "relative", gap: 8, marginTop: 16 }}>
      {onDelete ? (
        <button onClick={onDelete} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, minHeight: 44, borderRadius: 10, border: "none", background: "#fee2e2", color: "#991b1b", fontFamily: F, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
          <Trash2 size={15} /> {deleteLabel}
        </button>
      ) : <div style={{ flex: 1 }} />}
      <button onClick={() => setOpen((v) => !v)} aria-label="More actions" aria-expanded={open} style={{ width: 44, minHeight: 44, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 10, border: `1px solid ${T.border}`, background: "#fff", color: T.text, cursor: "pointer" }}>
        <MoreVertical size={18} />
      </button>
      {open && (
        <div role="menu" style={{ position: "absolute", right: 0, bottom: "calc(100% + 8px)", minWidth: 220, background: "#fff", border: `1px solid ${T.border}`, borderRadius: 12, boxShadow: "0 12px 32px rgba(0,0,0,0.14)", padding: 6, zIndex: 20 }}>
          {items.map((it) => (
            <button key={it.label} role="menuitem" onClick={() => { setOpen(false); it.onClick(); }} style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "11px 12px", border: "none", background: "none", borderRadius: 8, fontFamily: F, fontSize: 14, color: T.text, cursor: "pointer", textAlign: "left" }}>
              {it.icon} {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
